import { useEffect, useState } from 'react';

/**
 * Tracks the user's `prefers-reduced-motion` OS setting so components can
 * skip continuous / decorative animation (parallax, marquees, cursor
 * reactivity) while keeping essential state-change transitions.
 */
export default function usePrefersReducedMotion() {
  const supported = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
  const [reduced, setReduced] = useState(
    () => supported && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );

  useEffect(() => {
    if (!supported) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, [supported]);

  return reduced;
}

